import { Features } from '@backend/lib-feature-mgr';
import { useCallback } from 'react';

import { getDomainPublicURL } from '~/config';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useCheckFeatureEnabled, useTranslation } from '~/hooks';

export const useGetDomainPublicUrl = () => {
  const t = useTranslation();
  const { businessUnit, language } = useBusinessUnitContext();
  const externalLinksWithLanguageFeature = useCheckFeatureEnabled(Features.JobBoardExternalLinksWithLanguage);

  return useCallback(
    (pathKey: string) => {
      const languageConfig = externalLinksWithLanguageFeature ? `/${language}` : '';
      return `${getDomainPublicURL(businessUnit)}${languageConfig}/${t(`url.${pathKey}`)}`;
    },
    [businessUnit, language, externalLinksWithLanguageFeature],
  );
};
